import React, { useState, useEffect } from 'react';
import ListingPage from './listing-page/ListingPage';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { getAllTherapists } from '../../../helper/api.helper';
import { getOrgCode } from '../../../helper/utils.helper';
import TherapistListSkeletonCard from './TherapistListSkeletonCard';
import InstituteDetails from '../home/institute-details/InstituteDetails';

const TherapistList = () => {
  const [allTherapists, setAllTherapists] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    const orgCode = getOrgCode();
    getAllTherapists(orgCode)
      .then((res) => res.json())
      .then((res) => {
        if (res.status === 'success') {
          setAllTherapists(res.data);
        } else {
          toast.error(res.message);
          navigate('/');
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err.message);
      });
  }, []);

  return (
    <>
      <div className="outer-div flex-container">
        {isLoading ? (
          <div className="skeleton-div">
            <TherapistListSkeletonCard />
          </div>
        ) : (
          <div
            style={{
              padding: window.innerWidth > 600 ? 'var(--space-lg)' : 'var(--space-md)'
            }}>
            <div className="margin-bottom--lg">
              <InstituteDetails />
            </div>
            <div className="inner-div">
              {allTherapists
                ?.sort((a, b) => a.displayOrder - b.displayOrder)
                .map((therapist) => (
                  <ListingPage therapist={therapist} key={therapist.id} />
                ))}
            </div>
          </div>
        )}
        <style jsx>
          {`
            .outer-div {
              // margin-top: 80px;
              display: flex;
              justify-content: center;
              // align-items: center;
              min-height: 90vh;
              max-width: 1150px;
              margin: auto;
            }
            .skeleton-div {
              flex-grow: 1;
              max-width: 1150px;
              padding-bottom: 20px;
            }
            .inner-div {
              width: 70%;
              max-width: 900px;
              padding-bottom: 20px;
              margin: auto;
            }
            @media only screen and (max-width: 1050px) {
              .inner-div {
                width: 80%;
              }
            }

            @media only screen and (max-width: 950px) {
              .inner-div {
                width: 95%;
              }
            }
          `}
        </style>
      </div>
    </>
  );
};

export default TherapistList;
